<template>
  <v-container fluid class="apitoken-container pa-0 ma-0">
    <!-- Modern Header Section -->
    <div v-if="showHeader" class="header-section mb-6">
      <v-btn icon small class="header-close-btn" @click="dismissHeader">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
      <div class="d-flex align-center mb-4">
        <div class="header-icon-wrapper mr-4">
          <v-icon size="32" color="#FFFFFF">mdi-api</v-icon>
        </div>
        <div>
          <h1 class="page-title mb-1">External API</h1>
          <p class="page-subtitle mb-0">
            Integrate GoDial with your existing solutions using our RESTful API
          </p>
        </div>
        <v-spacer></v-spacer>
        <div class="d-none d-sm-flex">
          <v-chip
            small
            class="mr-2"
            color="rgba(255,255,255,0.2)"
            text-color="white"
          >
            <v-icon small left>mdi-code-braces</v-icon>
            Developer Tools
          </v-chip>
        </div>
      </div>
      <v-row class="feature-pills ma-0">
        <v-col cols="6" sm="4" md="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-api</v-icon>
            <span>RESTful API</span>
          </div>
        </v-col>
        <v-col cols="6" sm="4" md="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-key</v-icon>
            <span>API Token</span>
          </div>
        </v-col>
        <v-col cols="6" sm="4" md="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white"
              >mdi-book-open-variant</v-icon
            >
            <span>Documentation</span>
          </div>
        </v-col>
        <v-col cols="6" sm="4" md="3" class="pa-1">
          <div class="feature-pill">
            <v-icon small class="mr-2" color="white">mdi-code-json</v-icon>
            <span>JSON Format</span>
          </div>
        </v-col>
      </v-row>
    </div>

    <!-- Content Section -->
    <div style="padding: 0 12px;">
      <v-card
        class="customBorderRadius elevation-2"
        style="margin-bottom: 10px; padding: 10px;"
      >
        <v-container fluid>
          <div class="main-container">
            <!-- Left Section (API Documentation) -->
            <div class="sub-container">
              <h3>Documentation</h3>
              <v-sheet class="custom-input-container">
                <input
                  type="text"
                  class="custom-input"
                  :value="documentation"
                  readonly
                />
                <button class="custom-button" @click="openDocumentation">
                  Open
                </button>
              </v-sheet>
            </div>

            <!-- Right Section (API Token) -->
            <div class="sub-container">
              <h3>API Key</h3>
              <v-sheet class="custom-input-container">
                <input
                  v-model="token"
                  type="text"
                  class="custom-input"
                  readonly
                />
                <button class="custom-button" @click="copy(token)">
                  <v-icon size="22" color="white">mdi-content-copy</v-icon>
                </button>
              </v-sheet>
            </div>
          </div>

          <!-- Quick Start PDF Guide -->
          <div class="pdf-guide-banner mt-4">
            <div class="pdf-guide-info">
              <v-icon size="28" color="#4caf50" class="mr-3"
                >mdi-file-pdf-box</v-icon
              >
              <div>
                <div class="pdf-guide-title">External API — Quick Start Guide (PDF)</div>
                <div class="pdf-guide-subtitle">
                  A short, customer-friendly PDF covering every External API
                  endpoint (Teams, Accounts, Lists, Contacts, Tasks, Reports)
                  plus the Click-to-Call API. Ideal for sharing with
                  developers who are new to GoDial.
                </div>
              </div>
            </div>
            <div class="pdf-guide-actions">
              <v-btn
                color="#4caf50"
                dark
                depressed
                class="mr-2"
                @click="openApiGuidePdf"
              >
                <v-icon left>mdi-open-in-new</v-icon>View
              </v-btn>
              <v-btn color="#4caf50" outlined @click="downloadApiGuidePdf">
                <v-icon left>mdi-download</v-icon>Download
              </v-btn>
            </div>
          </div>
        </v-container>

        <v-divider class="my-4"></v-divider>

        <v-container fluid>
          <v-layout mx-1 row style="padding: 1rem;">
            <v-flex xs12 sm12 md12 style="padding-top: 20px;">
              <h3>GoDial API</h3>
            </v-flex>

            <v-flex>
              <p>
                Extend the features of GoDial and integrate with your existing
                solution using the GoDial API.
              </p>
            </v-flex>
          </v-layout>

          <v-layout xs12 sm12 md12 style="padding-top: 1rem;">
            <v-flex mt-4 mx-5>
              <h4>Philosophy of Operation</h4>

              <p>
                GoDial generates a Token for your company, which is listed above
                and is available only from the manager account. This token has
                to be passed on every call in the Authorization header.
              </p>

              <p>
                GoDial's CRM is based on Lists and Contacts. Each list is a
                collection of contacts. Similarly, Teams are a collection of
                members.
              </p>

              <p>
                To get started, obtain your token. You can start by adding
                members, adding a list, assigning a list to a member, then
                adding contacts to the list, finally viewing reports.
              </p>
            </v-flex>
          </v-layout>
        </v-container>

        <!-- Snackbar for Copy Confirmation -->
        <v-snackbar
          v-model="snackbar"
          :bottom="true"
          :right="true"
          timeout="2000"
        >
          Copied!
        </v-snackbar>
      </v-card>

      <v-card
        elevation="0"
        class="customBorderRadius"
        style="margin-bottom:10px; display:none;"
      >
        <v-layout mx-1 row style="padding: 1rem;">
          <v-flex xs12 sm12 md12 style="padding-top: 20px;">
            <h3>GoDial API</h3>
          </v-flex>

          <v-flex>
            <p>
              Extend the features of GoDial and integrate with your existing
              solution using the GoDial API.
            </p>
          </v-flex>
        </v-layout>

        <v-layout xs12 sm12 md12 style="padding-top: 1rem;">
          <v-flex mt-4 mx-5>
            <h4>Philosophy of Operation</h4>

            <p>
              GoDial generates a Token for your company, which is listed above
              and is available only from the manager account. This token has to
              be passed on every call in the Authorization header.
            </p>

            <p>
              GoDial’s CRM is based on Lists and Contacts. Each list is a
              collection of contacts. Similarly, Teams are a collection of
              members.
            </p>

            <p>
              To get started, obtain your token. You can start by adding
              members, adding a list, assigning a list to a member, then adding
              contacts to the list, finally viewing reports.
            </p>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="customBorderRadius elevation-2 my-4">
        <VariablesTab></VariablesTab>
      </v-card>
    </div>
  </v-container>
</template>

<v-card class="customBorderRadius my-4">
      <v-layout>
        <v-flex mt-4 mx-5>
          <h4>Example APIs</h4>
          <br />
          <v-expansion-panels focusable class="mb-4">
            <v-expansion-panel>
              <v-expansion-panel-header>Add a Team</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row mt-4>
                  <v-flex xs4 s3 m2 style="display:flex; justify-content:center;">
                    <v-btn style="padding:20px;margin-top:4px;" dark color="primarygrad">
                      POST
                    </v-btn>
                  </v-flex>
                  <v-flex xs8 s9 m10 style="display:flex; justify-content:center;">
                    <v-text-field v-model="teamUrl" readonly solo></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-card>
                      <v-tabs v-model="contentTab" background-color="primarygrad" dark grow show-arrows>
                        <v-tab v-for="item in tabsHeader" :key="item">
                          {{ item }}
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="contentTab">
                        <v-tab-item>
                          <v-card color="white" flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                                <tr>
                                  <td>access_token</td>
                                  <td>your_api_token</td>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <v-card style="background-color:#cfd1c9;">
                                <pre>

    {
      "name": "Team Name",
      "desc": "Team Description"
    }
                                </pre>
                              </v-card>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Add a Member</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row mt-4>
                  <v-flex xs4 s3 m2 style="display:flex; justify-content:center;">
                    <v-btn style="padding:20px;margin-top:4px;" dark color="primarygrad">
                      POST
                    </v-btn>
                  </v-flex>
                  <v-flex xs8 s9 m10 style="display:flex; justify-content:center;">
                    <v-text-field v-model="memberUrl" readonly solo></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-card>
                      <v-tabs v-model="contentTab" background-color="primarygrad" dark grow show-arrows>
                        <v-tab v-for="item in tabsHeader" :key="item">
                          {{ item }}
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="contentTab">
                        <v-tab-item>
                          <v-card color="white" flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                                <tr>
                                  <td>access_token</td>
                                  <td>your_api_token</td>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <v-card style="background-color:#cfd1c9;">
                                <pre>

    {
      "name": "Member Name",
      "email": "Member Email",
      "crmAccess": true/false,
      "skipCallAccess": true/false,
      "modifyUserAccess": true/false,
      "teamsId": [],
      "username": "Member username",
      "password": "Member Password",
      "role": "Manager/TeamManager/Agent",
      "phone": 0
    }
                                </pre>
                              </v-card>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Add a List</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row mt-4>
                  <v-flex xs4 s3 m2 style="display:flex; justify-content:center;">
                    <v-btn style="padding:20px;margin-top:4px;" dark color="primarygrad">
                      POST
                    </v-btn>
                  </v-flex>
                  <v-flex xs8 s9 m10 style="display:flex; justify-content:center;">
                    <v-text-field v-model="listUrl" readonly solo></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-card>
                      <v-tabs v-model="contentTab" background-color="primarygrad" dark grow show-arrows>
                        <v-tab v-for="item in tabsHeader" :key="item">
                          {{ item }}
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="contentTab">
                        <v-tab-item>
                          <v-card color="white" flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                                <tr>
                                  <td>access_token</td>
                                  <td>your_api_token</td>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <v-card style="background-color:#cfd1c9;">
                                <pre>

    {
      "name": "List Name",
      "desc": "List Description",
      "teamsId": "Id of team"
    }
                                </pre>
                              </v-card>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Add a Contact</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row mt-4>
                  <v-flex xs4 s3 m2 style="display:flex; justify-content:center;">
                    <v-btn style="padding:20px;margin-top:4px;" dark color="primarygrad">
                      POST
                    </v-btn>
                  </v-flex>
                  <v-flex xs8 s9 m10 style="display:flex; justify-content:center;">
                    <v-text-field v-model="contactUrl" readonly solo></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-card>
                      <v-tabs v-model="contentTab" background-color="primarygrad" dark grow show-arrows>
                        <v-tab v-for="item in tabsHeader" :key="item">
                          {{ item }}
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="contentTab">
                        <v-tab-item>
                          <v-card color="white" flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                                <tr>
                                  <td>access_token</td>
                                  <td>your_api_token</td>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <v-card style="background-color:#cfd1c9;">
                                <pre>

    {
      "name": "Contact Name",
      "email": "Contact Email",
      "phone": "Contact Phone Number",
      "secondPhone": "Contact Alternative Number",
      "companyName": "Company Name of Contact",
      "note": "Note for the Contact",
      "remarks": "Remarks for the Contact",
      "extra": "",
      "listId": "List Id of in which Contact is to be saved",
      "accountsId": "Accounts Id where Contact is to be assigned"
    }
                                </pre>
                              </v-card>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>Assign List to a Member</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row mt-4>
                  <v-flex xs4 s3 m2 style="display:flex; justify-content:center;">
                    <v-btn style="padding:20px;margin-top:4px;" dark color="primarygrad">
                      POST
                    </v-btn>
                  </v-flex>
                  <v-flex xs8 s9 m10 style="display:flex; justify-content:center;">
                    <v-text-field v-model="assignUrl" readonly solo></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-card>
                      <v-tabs v-model="contentTab" background-color="primarygrad" dark grow show-arrows>
                        <v-tab v-for="item in tabsHeader" :key="item">
                          {{ item }}
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="contentTab">
                        <v-tab-item>
                          <v-card color="white" flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                                <tr>
                                  <td>access_token</td>
                                  <td>your_api_token</td>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <v-card style="background-color:#cfd1c9;">
                                <pre>

    {
      "accountsId": "ID of Member",
      "listsId": "ID of List"
    }
                                </pre>
                              </v-card>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>View Report</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row mt-4>
                  <v-flex xs4 s3 m2 style="display:flex; justify-content:center;">
                    <v-btn style="padding:20px;margin-top:4px;" dark color="primarygrad">
                      POST
                    </v-btn>
                  </v-flex>
                  <v-flex xs8 s9 m10 style="display:flex; justify-content:center;">
                    <v-text-field v-model="reportUrl" readonly solo></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-card>
                      <v-tabs v-model="contentTab" background-color="primarygrad" dark grow show-arrows>
                        <v-tab v-for="item in tabsHeader" :key="item">
                          {{ item }}
                        </v-tab>
                      </v-tabs>

                      <v-tabs-items v-model="contentTab">
                        <v-tab-item>
                          <v-card color="white" flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                                <tr>
                                  <td>access_token</td>
                                  <td>your_api_token</td>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <v-card style="background-color:#cfd1c9;">
                                <pre>

    {
      "search": "Generate Report based on search keyword ",
      "field": "Generate Report based on field",
      "range": ["Start Date in YYYY-MM-DD format",
               "End Date in YYYY-MM-DD format"],
      "lists": ["Generate Report based on array of ListIDs"],
      "users": ["Generate Report based on array of MemberIDs"],
      "dispos": ["Generate Report based on array of dispositions"],
      "limit": 0,
      "skip": 0
    }
                                </pre>
                              </v-card>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>

                        <v-tab-item>
                          <v-card flat>
                            <v-card-text>
                              <table>
                                <tr>
                                  <th>key</th>
                                  <th>value</th>
                                </tr>
                              </table>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
      </v-layout>
      <!-- <v-layout>
        <v-flex xs12 sm12 md12 style="padding: 5px;">
          <v-btn style="margin-block:20px; margin-left:10px; color:primary; " href="https://godial.stoplight.io/"
            target="_blank">FULL API SPECS</v-btn>
        </v-flex>
      </v-layout> -->
    </v-card>

<script>
import { mapState } from "vuex";
import Breadcrumbs from "../components/breadcrumbs.vue";
import VariablesTab from "../components/VariablesTab.vue";
export default {
  components: {
    VariablesTab,
  },
  data() {
    return {
      showHeader: false,
      token: "",
      snackbar: false,
      teamUrl: "https://enterprise.godial.cc/meta/api/externals/team/add",
      memberUrl: "https://enterprise.godial.cc/meta/api/externals/accounts/add",
      listUrl: "https://enterprise.godial.cc/meta/api/externals/lists/add",
      contactUrl: "https://enterprise.godial.cc/meta/api/externals/contact/add",
      assignUrl: "https://enterprise.godial.cc/meta/api/externals/lists/assign",
      reportUrl: "https://enterprise.godial.cc/meta/api/externals/log/list",
      contentTab: null,
      tabsHeader: ["Query", "Headers", "Body", "Path"],
      textTab:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      documentation:
        "https://godial.stoplight.io/docs/godial/cd4edf0828dd6-go-dial-crm-external-api",
    };
  },
  computed: {
    ...mapState(["ENDPOINT"]),
  },

  created() {
    this.showHeader =
      localStorage.getItem("apiTokenHeaderDismissed") !== "true";
    this.generateToken();
  },
  methods: {
    dismissHeader() {
      this.showHeader = false;
      localStorage.setItem("apiTokenHeaderDismissed", "true");
    },
    openDocumentation() {
      if (this.documentation) {
        window.open(this.documentation, "_blank");
      } else {
        this.snackbarMessage = "No documentation URL available";
        this.snackbar = true;
      }
    },
    openApiGuidePdf() {
      window.open("/GoDial-External-API-Guide.pdf", "_blank");
    },
    downloadApiGuidePdf() {
      const link = document.createElement("a");
      link.href = "/GoDial-External-API-Guide.pdf";
      link.download = "GoDial-External-API-Guide.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    generateToken() {
      const self = this;
      var aToken = self.$store.getters.user.token;

      self.$http
        .get(`${this.ENDPOINT}/externals/token?access_token=${aToken}`)
        .then((response) => {
          this.token = response.body.id;
        })
        .catch((err) => {
          self.$swal({ type: "error", text: err.body.error.message });
        });
    },
    copy(link) {
      const self = this;
      this.$copyText(link).then(
        function(e) {
          self.snackbar = true;
          console.log(e);
        },
        function(e) {
          console.log(e);
        },
      );
    },
  },
};
</script>
<style scoped>
.apitoken-container {
  background-color: var(--v-background-base, #f5f5f5);
  min-height: 100vh;
}

.theme--dark .apitoken-container {
  background-color: #121212 !important;
}

.pdf-guide-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 20px;
  border: 1px solid rgba(76, 175, 80, 0.3);
  border-radius: 10px;
  background: linear-gradient(
    90deg,
    rgba(76, 175, 80, 0.08) 0%,
    rgba(76, 175, 80, 0.02) 100%
  );
}

.theme--dark .pdf-guide-banner {
  background: linear-gradient(
    90deg,
    rgba(76, 175, 80, 0.15) 0%,
    rgba(76, 175, 80, 0.05) 100%
  );
  border-color: rgba(76, 175, 80, 0.4);
}

.pdf-guide-info {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.pdf-guide-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 2px;
}

.pdf-guide-subtitle {
  font-size: 13px;
  opacity: 0.75;
  line-height: 1.4;
}

.pdf-guide-actions {
  display: flex;
  flex-shrink: 0;
}

@media (max-width: 600px) {
  .pdf-guide-banner {
    flex-direction: column;
    align-items: flex-start;
  }
  .pdf-guide-actions {
    width: 100%;
  }
}

.header-section {
  background: linear-gradient(135deg, #37cf37 0%, #2ba82b 100%);
  border-radius: 12px;
  padding: 24px;
  color: white;
  box-shadow: 0 4px 20px rgba(55, 207, 55, 0.3);
}

.header-icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.page-title {
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.page-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.95);
  margin: 0;
}

.feature-pills {
  margin-top: 16px;
}

.feature-pill {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 25px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 13px;
  font-weight: 500;
  height: 100%;
  transition: all 0.3s ease;
}

.feature-pill:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
}

table {
  width: 100%;
}

pre {
  overflow-x: scroll;
}

.var-header {
  /* margin: 2rem 1rem; */
}

.custom-bg {
  background-color: #f5f5f5;
}

/* Main container */
.custom-input-container {
  display: flex;
  align-items: center;
  width: 100%;
  /* Adjust width as needed */
  border: 1px solid #000000;
  border-radius: 8px;
  overflow: hidden;
  background-color: #f9f9f9;
}

/* Non-editable input */
.custom-input {
  flex: 1;
  padding: 10px;
  border: none;
  background: transparent;
  outline: none;
  font-size: 16px;
}

/* Button */
.custom-button {
  background-color: #4caf50;
  color: white;
  padding: 10px 16px;
  border: none;
  cursor: pointer;
  font-size: 16px;
  transition: 0.3s;
}

.custom-button:hover {
  background-color: #45a049;
}

.main-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sub-container {
  width: 50%;
  margin-inline: 0.5rem;
}

.sub-container h3 {
  margin-bottom: 0.5rem;
}

@media (max-width: 600px) {
  .sub-container {
    width: 100%;
    margin-inline: 0;
    margin-block: 0.5rem;
  }

  .main-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
}

.v-tabs-items {
  border-radius: 12px !important;
}

/* Dark Theme Styles */
.theme--dark .customBorderRadius {
  background: #1e1e1e !important;
}

.theme--dark .main-container h3,
.theme--dark .sub-container h3 {
  color: #e0e0e0 !important;
}

.theme--dark .custom-input-container {
  background-color: #2d2d2d !important;
  border-color: #404040 !important;
}

.theme--dark .custom-input {
  color: #e0e0e0 !important;
  background: transparent !important;
}

.theme--dark .v-card h3,
.theme--dark .v-card h4 {
  color: #e0e0e0 !important;
}

.theme--dark .v-card p {
  color: #a0a0a0 !important;
}

/* Ensure header section text stays white */
.theme--dark .header-section .page-title {
  color: white !important;
}

.theme--dark .header-section .page-subtitle {
  color: rgba(255, 255, 255, 0.95) !important;
}

.theme--dark .header-section .feature-pill {
  color: white !important;
}

.theme--dark table,
.theme--dark th,
.theme--dark td {
  border-color: #404040 !important;
  color: #e0e0e0 !important;
}

.theme--dark th {
  background: #2d2d2d !important;
}

.theme--dark td {
  background: #1e1e1e !important;
}

.theme--dark .v-expansion-panel {
  background: #1e1e1e !important;
}

.theme--dark .v-expansion-panel-header {
  color: #e0e0e0 !important;
}

.theme--dark .v-expansion-panel-content {
  background: #1e1e1e !important;
}

.theme--dark .v-text-field.v-text-field--solo .v-input__slot {
  background: #2d2d2d !important;
}

.theme--dark .v-text-field.v-text-field--solo input {
  color: #e0e0e0 !important;
}

.theme--dark pre {
  background-color: #2d2d2d !important;
  color: #e0e0e0 !important;
}

.theme--dark .v-card {
  background: #1e1e1e !important;
}

.theme--dark .v-card-text {
  color: #e0e0e0 !important;
}

.theme--dark .v-tabs-items {
  background: #1e1e1e !important;
}
</style>
